var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"comp text-center"},[_c('img',{staticClass:"logoimg",attrs:{"src":_vm.loadingimg,"alt":""}}),_c('v-progress-circular',{staticClass:"spinner",attrs:{"indeterminate":"","color":"blue"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }